<div class="row">
    <div class="col-md-12">
        <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
            <mat-card-content class="mat-mdc-card-content text-right">
                <span class="title"> {{ 'CreateNewContract' | translate}}</span>
                <table class="table">
                    <tr>
                        <td class="td-title">{{ 'ClientName' | translate }}</td>
                        <td>{{Client?.name}}</td>
                    </tr>
                    <tr>
                        <td class="td-title">{{ 'Phone' | translate }}</td>
                        <td>{{Client?.clientPhone}}</td>
                    </tr>
                    <tr>
                        <td class="td-title">{{ 'Address' | translate }}</td>
                        <td>{{Client?.clientAddress}}</td>
                    </tr>
                    <tr>
                        <td class="td-title">{{ 'Email' | translate }}</td>
                        <td>{{Client?.email}}</td>
                    </tr>
                </table>

                <span class="title"> {{ 'RequestDetails' | translate}}</span>
                <div *ngIf="CostCalc?.length==0;then NoCostCalc else CostCalcData"></div>

                <ng-template #NoCostCalc>
                    <div class="col-md-12 text-center">
                        <p> {{ 'NoInvoicesYet' | translate }}</p>
                    </div>
                </ng-template>

                <ng-template #CostCalcData>
                    <mat-checkbox color="primary" (change)="CheckAll()">
                        {{'checkAll'|translate}}
                    </mat-checkbox>
                    <form [formGroup]="form">
                        <div class="row m-t-20">
                            <div class="col-md-6" *ngFor="let cost of CostCalc;">
                                <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                                    <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                                        <mat-card-title class="mat-mdc-card-title text-white">
                                            {{cost.orderName}}
                                        </mat-card-title>
                                        <div class="check">
                                            <mat-checkbox color="primary" (change)="ChooseProduct($event,cost.id)"
                                                [checked]="cost.id!=null && selectedIds?.includes(cost.id) || allChecked"
                                                value="{{cost.id!=null && selectedIds?.includes(cost.id) || allChecked}}"
                                                formControlName="CheckedProduct_{{cost.id}}">
                                            </mat-checkbox>
                                        </div>
                                    </mat-card-header>
                                    <mat-card-content class="mat-mdc-card-content text-center">
                                        <div class="row">
                                            <div class="col-md-2 justify-content-center">
                                                <img alt="{{cost.orderName}}" width="80" height="80" class="m-auto ms-5"
                                                    src="{{cost.pathFile | adjust_image_path}}">
                                            </div>
                                            <div class="col-md-9 text-right">
                                                <table class="table w-100">
                                                    <tr>
                                                        <td colspan="2">
                                                            <span class="subCategoryName">{{
                                                                cost.subCategoryName}}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span class="span-title">{{ 'Length' | translate }} :
                                                            </span>
                                                            <span>{{ cost.height}} {{ 'm' | translate }}</span>
                                                        </td>
                                                        <td>
                                                            <span class="span-title"> {{ 'width' | translate }} :
                                                            </span>
                                                            <span>{{ cost.width }} {{ 'm' | translate }}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <span class="span-title">{{ 'Count' | translate }} : </span>
                                                            <span>{{ cost.count??1 }}</span>
                                                        </td>
                                                        <td>
                                                            <span class="span-title">{{ 'Color' | translate }} :</span>
                                                            <span> {{ cost.colorName}}</span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="tblTitle">
                                            <span>{{ 'TotalCost' | translate}} : </span>
                                            <span>{{cost.totalPrice??0}} * {{cost.count??1}} =
                                                {{ClacTotalCost(cost.totalPrice,cost.count??1)}}
                                                {{'EGP'|translate}}</span>
                                        </div>

                                        <div class="calendar" *ngIf="cost.id!=null &&
                                            selectedIds?.includes(cost.id) || allChecked">
                                            <div class="row">
                                                <div class="col-md-4 div-title">
                                                    <mat-label class="title">
                                                        {{ 'InstallationDate' | translate}}
                                                    </mat-label>
                                                </div>
                                                <div class="col-md-8">
                                                    <mat-form-field appearance="outline" class="w-100 m-b-10">
                                                        <input matInput [matDatepicker]="picker"
                                                            formControlName="InstallationDate_{{cost.id}}">
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="picker"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </form>
                </ng-template>

                <div *ngIf="formErrors.length>0">
                    <div *ngFor="let error of formErrors">
                        <p class="validation-error">{{ error }}
                        </p>
                    </div>
                </div>
                <div class="divBtn">
                    <button class="btnEnterPaymentsNumber" (click)="EnterPaymentsNumber()" *ngIf="CostCalc?.length!=0">
                        {{ 'EnterPaymentsNumber' | translate}}
                    </button>

                    <button mat-button class="Cancelbtn" (click)="Cancel()"> {{ 'Cancel' | translate}}</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
